import ConsumerListingPanel from './consumerListingPanel.container'

export default ConsumerListingPanel